import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { Snippet } from './Snippet';
export function Results(props) {
  if (!props.collection || props.collection.items.length === 0) {
    return null;
  }
  return /*#__PURE__*/React.createElement("section", {
    className: "DocSearch-Hits"
  }, /*#__PURE__*/React.createElement("div", {
    className: "DocSearch-Hit-source"
  }, props.title), /*#__PURE__*/React.createElement("ul", props.getListProps(), props.collection.items.map(function (item, index) {
    return /*#__PURE__*/React.createElement(Result, _extends({
      key: [props.title, item.objectID].join(':'),
      item: item,
      index: index
    }, props));
  })));
}
function Result(_ref) {
  var item = _ref.item,
    index = _ref.index,
    renderIcon = _ref.renderIcon,
    renderAction = _ref.renderAction,
    getItemProps = _ref.getItemProps,
    onItemClick = _ref.onItemClick,
    collection = _ref.collection,
    hitComponent = _ref.hitComponent;
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isDeleting = _React$useState2[0],
    setIsDeleting = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    isFavoriting = _React$useState4[0],
    setIsFavoriting = _React$useState4[1];
  var action = React.useRef(null);
  var Hit = hitComponent;
  function runDeleteTransition(cb) {
    setIsDeleting(true);
    action.current = cb;
  }
  function runFavoriteTransition(cb) {
    setIsFavoriting(true);
    action.current = cb;
  }
  return /*#__PURE__*/React.createElement("li", _extends({
    className: ['DocSearch-Hit', item.__docsearch_parent && 'DocSearch-Hit--Child', isDeleting && 'DocSearch-Hit--deleting', isFavoriting && 'DocSearch-Hit--favoriting'].filter(Boolean).join(' '),
    onTransitionEnd: function onTransitionEnd() {
      if (action.current) {
        action.current();
      }
    }
  }, getItemProps({
    item: item,
    source: collection.source,
    onClick: function onClick() {
      onItemClick(item);
    }
  })), /*#__PURE__*/React.createElement(Hit, {
    hit: item
  }, /*#__PURE__*/React.createElement("div", {
    className: "DocSearch-Hit-Container"
  }, renderIcon({
    item: item,
    index: index
  }), item["hierarchy.".concat(item.type)] && item.type === 'lvl0' && /*#__PURE__*/React.createElement("div", {
    className: "DocSearch-Hit-content-wrapper"
  }, /*#__PURE__*/React.createElement(Snippet, {
    className: "DocSearch-Hit-title",
    hit: item,
    attribute: "hierarchy.lvl0"
  })), item["hierarchy.".concat(item.type)] && item.type === 'lvl1' && /*#__PURE__*/React.createElement("div", {
    className: "DocSearch-Hit-content-wrapper"
  }, /*#__PURE__*/React.createElement(Snippet, {
    className: "DocSearch-Hit-title",
    hit: item,
    attribute: "hierarchy.lvl1"
  }), item.content && /*#__PURE__*/React.createElement(Snippet, {
    className: "DocSearch-Hit-path",
    hit: item,
    attribute: "content"
  })), item["hierarchy.".concat(item.type)] && (item.type === 'lvl2' || item.type === 'lvl3' || item.type === 'lvl4' || item.type === 'lvl5' || item.type === 'lvl6') && /*#__PURE__*/React.createElement("div", {
    className: "DocSearch-Hit-content-wrapper"
  }, /*#__PURE__*/React.createElement(Snippet, {
    className: "DocSearch-Hit-title",
    hit: item,
    attribute: "hierarchy.".concat(item.type)
  }), /*#__PURE__*/React.createElement(Snippet, {
    className: "DocSearch-Hit-path",
    hit: item,
    attribute: "hierarchy.lvl1"
  })), item.type === 'content' && /*#__PURE__*/React.createElement("div", {
    className: "DocSearch-Hit-content-wrapper"
  }, /*#__PURE__*/React.createElement(Snippet, {
    className: "DocSearch-Hit-title",
    hit: item,
    attribute: "content"
  }), /*#__PURE__*/React.createElement(Snippet, {
    className: "DocSearch-Hit-path",
    hit: item,
    attribute: "hierarchy.lvl1"
  })), renderAction({
    item: item,
    runDeleteTransition: runDeleteTransition,
    runFavoriteTransition: runFavoriteTransition
  }))));
}